import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {  useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, } from '../../../../../utils';
import { toast } from '../../../../../utils';
import axios from 'axios';
import { useRef } from 'react';

const TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.main?.name
  }
];

export const PurchaseRequisitionAddDetails = ({
  onClose,
  onAdd,
  productDropdown,
  setFilteredServiceList,
  filteredServiceList,
  setProductDropdown,
  isEditMode,
  editData,
}) => {
  const [input, setInput] = useState('');
  const [totalStock, setTotalStock] = useState(0);
    const reqQtyRef = useRef(null);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        product_name: Yup.string().required('Please Enter Product'),
        req_qty:Yup.string().required('Please Enter Requied Quantity') 
     })
    ),
    defaultValues: {

    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues
    };
    onAdd(transformedValues);
    reset();
  };

  const handleServiceSelection = (row) => {
    methods.resetField('product');
    setValue('product_name', row?.main?.name);
    setValue('product',row?._id);
    handleTotalStock(row?._id);
    handleTotalConsumption(row?._id);
       setTimeout(() => {
      reqQtyRef.current?.focus();
    }, 50); 
  };


  useEffect(() => {
    handleProductSearch(input);
  }, [input]);

  const handleProductSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${50}&name=${lowercasedInput}`);
      if (response.data.success) {
        setProductDropdown(response.data.data);
        setFilteredServiceList(response.data.data);
      } else {
        toast('Error in fetching data', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
    }
  };

  const handleInputChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleTotalStock = async (rowId) => {
    try {
      const response = await axios.get(`${BASE_URL}/stock-master-product/total?name=${rowId}`);
      if (response.data.success && response.data.data) {
        const totalQuantity = response.data.data.totalStock;
        setTotalStock(totalQuantity);
        setValue('curr_stock', totalQuantity);
      }
    } catch (error) {
      console.error('Error during search:', error);
    }
  };

  const handleTotalConsumption = async (rowId) => {
    try {
      const response = await axios.get(`${BASE_URL}/stock-master-product/consumption?name=${rowId}`);
      if (response.data.success && response.data.data) {
        const totalQuantity15Dyas = response.data.data.totalOutQty15Days;
        const totalQuantity30Dyas = response.data.data.totalOutQty30Days;
        setValue('fifteen_days_cons', totalQuantity15Dyas);
        setValue('thirty_days_cons', totalQuantity30Dyas);
      }
    } catch (error) {
      console.error('Error during search:', error);
    }
  };
    useEffect(() => {
    if (isEditMode && editData) {
      reset({
        product_name: editData.product_name || editData?.product?.main?.name,
        product:editData.product || editData?.product._id,
        req_qty : editData?.req_qty,
        curr_stock : editData?.curr_stock,
        remarks: editData?.remarks,
        fifteen_days_cons : editData.fifteen_days_cons,
        thirty_days_cons : editData.thirty_days_cons,
        _id : editData?._id,
      });
    } else {
      reset();
    }
  }, [isEditMode, editData, reset]);


  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="0px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Product Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>

      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={4}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Typography variant="h6">No. Of Product :- {productDropdown.length}</Typography>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
              <MuiTextField
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    padding: '0'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 14px'
                  }
                }}
                label="Search Product"
                variant="outlined"
                value={input}
                onChange={handleInputChange}
                InputProps={{
                  style: {
                    fontSize: '12px',
                    fontWeight: 600
                  }
                }}
              />
            </Stack>
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              sx={{ fontSize: '32px' }}
              data={filteredServiceList || []}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}
            />
          </Grid>
          <Grid item xs={8}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2, marginTop: '5%' }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                <TextField sx={{ flex: 0.4 }} name="product_name" disabled />
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Req. Qty</Typography>
                <TextField sx={{ flex: 0.38 }} name="req_qty" type="number"  inputRef={reqQtyRef} />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Current Stock</Typography>
                <TextField sx={{ flex: 0.38 }} name="curr_stock" disabled />
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                <TextField sx={{ flex: 0.38 }} name="remarks" />
              </Stack>

              <Box>
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Analysis</Typography>
                <Box
                  sx={{
                    height: '3px',
                    backgroundColor: 'gray',
                    width: '100%',
                    mt: 1,
                    mb: 3
                  }}
                />
              </Box>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Pending Indent Qty</Typography>
                <TextField sx={{ flex: 0.4 }} name="pending_indent_qty" disabled />
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>15Days Cons.</Typography>
                <TextField sx={{ flex: 0.38 }} name="fifteen_days_cons" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.23, fontWeight: 700, fontSize: '1.4rem' }}>30 Days Cons.</Typography>
                <TextField sx={{ flex: 0.3 }} name="thirty_days_cons" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
